import {
  GET_SERVICE_QUEUES_QUERY,
  GET_SERVICE_USERS_QUERY,
  GET_USERS_AVAILABILITY_ACTIVITY_QUERY,
} from 'src/constants/operations';

const noRetryOperations = [
  GET_SERVICE_QUEUES_QUERY,
  GET_SERVICE_USERS_QUERY,
  GET_USERS_AVAILABILITY_ACTIVITY_QUERY,
];

export default noRetryOperations;
